var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    fillRule: "evenodd",
    points: "6 4.443 7.367 3 14 10 7.367 17 6 15.557 11.266 10"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-right.136c9227.svg";
export { ForwardRef as ReactComponent };